import { DataFieldType } from "src/types/data-field.types";
import { createNodeDef } from "../../nodes.helpers";
import { randAddress } from "@ngneat/falso";

export const randAddressNodeDef = createNodeDef({
  type: "randAddress",
  displayName: "Address",
  defaultName: "address",
  fields: [
    { type: DataFieldType.BOOLEAN, key: "includeCounty", label: "County" },
    { type: DataFieldType.BOOLEAN, key: "includeCountry", label: "Country" },
  ],
  initialData: () => ({ includeCounty: true, includeCountry: true }),
  generate: ({ node }) => {
    return randAddress({
      includeCounty: node.data.includeCounty,
      includeCountry: node.data.includeCountry,
    });
  },
});
